import { createVNode as o, mergeProps as a } from "vue";
import i from "../node_modules/@pf-ui/pf-icon-svg/es/asn/InfoCircleOutlinedStandard.js";
import d from "../components/PfIcon.js";
const r = (t, e) => {
  const n = {
    ...t,
    ...e.attrs
  };
  return o(d, a(n, {
    icon: i
  }), null);
};
r.displayName = "InfoCircleOutlinedStandard";
r.inheritAttrs = !1;
export {
  r as default
};
